import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { getVersionUDI, getSoftwareVersion, getAppIsOnMaintenance } from '../functions/api';

type DataContextType = {
    currentUserId: string | null;
    setCurrentUserId: React.Dispatch<React.SetStateAction<string | null>>;
    currentUserRole: string | null;
    setCurrentUserRole: React.Dispatch<React.SetStateAction<string | null>>;
    currentUserFullName: string | null;
    setCurrentUserFullName: React.Dispatch<React.SetStateAction<string | null>>;
    currentUserCode: string | null;
    setCurrentUserCode: React.Dispatch<React.SetStateAction<string | null>>;
    currentUserTemporaryPassword: boolean;
    setCurrentUserTemporaryPassword: React.Dispatch<React.SetStateAction<boolean>>;
    currentUserPurchasedRequests: number | null;
    setCurrentUserPurchasedRequests: React.Dispatch<React.SetStateAction<number | null>>;
    softwareVersionProp: string;
    setSoftwareVersionProp: React.Dispatch<React.SetStateAction<string>>;
    versionUDI: string;
    setVersionUDI: React.Dispatch<React.SetStateAction<string>>;
    isOnMaintenance: boolean;
    setIsOnMaintenance: React.Dispatch<React.SetStateAction<boolean>>;
};

type DataProviderProps = {
    children: ReactNode;
};

const DataContext = createContext({} as DataContextType);

const DataProvider = ({ children }: DataProviderProps) => {
    const [currentUserId, setCurrentUserId] = useState<string | null>(null);
    const [currentUserRole, setCurrentUserRole] = useState<string | null>(null);
    const [currentUserFullName, setCurrentUserFullName] = useState<string | null>(null);
    const [currentUserCode, setCurrentUserCode] = useState<string | null>(null);
    const [currentUserTemporaryPassword, setCurrentUserTemporaryPassword] = useState(false);
    const [currentUserPurchasedRequests, setCurrentUserPurchasedRequests] = useState<number | null>(
        null
    );

    const [softwareVersionProp, setSoftwareVersionProp] = useState('...');
    const [versionUDI, setVersionUDI] = useState('...');
    const [isOnMaintenance, setIsOnMaintenance] = useState(false);

    useEffect(() => {
        const fetchVersions = async () => {
            setSoftwareVersionProp(await getSoftwareVersion());
            setVersionUDI(await getVersionUDI());
        };
        fetchVersions();
    }, []);

    useEffect(() => {
        //llamada a getAppIsOnMaintenance y nueva variable de estado si es necesario
        const checkMaintenance = async () => {
            const isOnMaintenance = await getAppIsOnMaintenance();
            console.log('App maintenance status:', isOnMaintenance);
            // Aquí podrías guardar isOnMaintenance en el estado si es necesario
            setIsOnMaintenance(isOnMaintenance ? true : false);
        };

        checkMaintenance();
    }, []);

    return (
        <DataContext.Provider
            value={{
                currentUserId,
                setCurrentUserId,
                currentUserRole,
                setCurrentUserRole,
                currentUserFullName,
                setCurrentUserFullName,
                currentUserCode,
                setCurrentUserCode,
                currentUserTemporaryPassword,
                setCurrentUserTemporaryPassword,
                currentUserPurchasedRequests,
                setCurrentUserPurchasedRequests,
                softwareVersionProp,
                setSoftwareVersionProp,
                versionUDI,
                setVersionUDI,
                isOnMaintenance,
                setIsOnMaintenance
            }}
        >
            {children}
        </DataContext.Provider>
    );
};

export const useDataContext = () => useContext(DataContext);

export default DataProvider;
